export const options = [
    { label: 'Commercial', value: 0 },
    { label: 'Informational', value: 1 },
    { label: 'Navigational', value: 2 },
    { label: 'Transactional', value: 3 },
];
